const m = {
  'In arrivo nella v2': 'Coming soon in v2',
  'Questa sezione sarà ridisegnata con la nuova estetica NeoFlux.': 'This section will be redesigned with the new NeoFlux look.',
  'Torna alla pagina iniziale': 'Back to the start page',
};
export default m;
